/* Zeepy — transparent overlay header.

   Finds the section the header should float over — which is NOT always the
   first one. A campaign page starts with a thin announcement bar; the header
   should sit below that and overlay the hero underneath it. So we skip any
   leading sections shorter than the header and treat the first tall one as
   the hero, then offset the header by the height of whatever came before. */
(function () {
  'use strict';

  var group, hero, ticking = false;

  function sections() {
    var main = document.getElementById('MainContent');
    if (!main) return [];
    return [].slice.call(main.children).filter(function (el) {
      return el.classList && el.classList.contains('shopify-section') && el.offsetHeight > 0;
    });
  }

  function findHero() {
    var list = sections();
    if (!list.length) return { hero: null, offset: 0 };

    var headerH = group ? group.offsetHeight : 0;
    var offset = 0;

    for (var i = 0; i < list.length; i++) {
      // A section taller than the header is a real hero; anything shorter
      // (announcement bar, sign-off line) is a strip the header sits below.
      if (list[i].offsetHeight > headerH * 1.2) {
        return { hero: list[i], offset: offset };
      }
      offset += list[i].offsetHeight;
    }
    return { hero: list[0], offset: 0 };
  }

  function measure() {
    if (!group) return;

    var found = findHero();
    var headerH = group.offsetHeight;

    if (hero && hero !== found.hero) hero.classList.remove('zc-header-hero');
    hero = found.hero;
    if (hero) hero.classList.add('zc-header-hero');

    var root = document.documentElement.style;
    root.setProperty('--zc-header-h', headerH + 'px');
    root.setProperty('--zc-header-top', found.offset + 'px');
  }

  function isScrolled() {
    if (!hero) return window.scrollY > 120;
    var headerH = group ? group.offsetHeight : 0;
    // Solid only once the hero has genuinely scrolled up behind the header.
    return hero.getBoundingClientRect().bottom <= headerH + 8;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      document.body.classList.toggle('zc-header-scrolled', isScrolled());
      ticking = false;
    });
  }

  function refresh() {
    group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return;
    measure();
    onScroll();
  }

  function init() {
    if (document.body.classList.contains('zc-header-solid')) return;
    group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return;

    refresh();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });

    // Height can change after fonts load, images decode, or the announcement
    // bar is dismissed — keep the measurement honest.
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      ro.observe(group);
      var main = document.getElementById('MainContent');
      if (main) ro.observe(main);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    window.addEventListener('load', refresh);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
